import { IGetters } from '@/models/store/getters.interface';
import state from './state';

const getters: IGetters = {
	errorMessage: () => {
		return state.errorMessage;
	},
	router: () => {
		return state.router;
	},
	selectedFileUpload: () => {
		return state.selectedFileUpload;
	},
	selectedImport: () => {
		const foundImport = state.storedImports.find(
			(imported) => imported.id === state.router.props.id
		);
		return foundImport ? foundImport : null;
	},
	standAloneLogin: () => {
		return state.standAloneLogin;
	},
	storedImports: () => {
		return state.storedImports;
	}
};

export default getters;
